import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, FileText, BookOpen } from 'lucide-react';

const BlogNavigation = () => {
  const location = useLocation();
  
  const isActive = (path) => {
    if (path === '/blog' && location.pathname === '/blog') return true;
    if (path !== '/blog' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <nav className="bg-white border-b border-gray-100">
      <div className="container mx-auto px-4">
        <div className="flex items-center space-x-8 py-3">
          {/* Breadcrumbs */}
          <div className="flex items-center space-x-2 text-sm">
            <Link 
              to="/" 
              className="flex items-center space-x-1 text-gray-500 hover:text-gray-700 transition-colors"
            >
              <Home className="w-4 h-4" />
              <span>Home</span>
            </Link>
            <span className="text-gray-300">/</span>
            <span className="text-gray-900 font-medium">Blog</span>
          </div>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-6 ml-auto">
            <Link
              to="/blog"
              className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                isActive('/blog') && location.pathname === '/blog'
                  ? 'bg-indigo-100 text-indigo-700'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              }`}
            >
              <BookOpen className="w-4 h-4" />
              <span>All Articles</span>
            </Link>
            
            <div className="w-px h-6 bg-gray-200"></div>
            
            <Link
              to="/login"
              className="flex items-center space-x-2 text-indigo-600 hover:text-indigo-700 text-sm font-medium transition-colors"
            >
              <FileText className="w-4 h-4" />
              <span>Try Converter</span>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default BlogNavigation;